import { ISaveAsPatchContext } from './saveAsPatchModalContext';

export enum SaveAsPatchActionTypes {
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_TYPE_OF_CHANGES = 'SET_TYPE_OF_CHANGES',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	SET_PROPERTIES = 'SET_PROPERTIES',
	CHANGE_PRICE = 'CHANGE_PRICE',
	CHANGE_SUPPLEMENT_PRICE = 'CHANGE_SUPPLEMENT_PRICE',
	CHANGE_QUANTITY_MAX_LIMIT = 'CHANGE_QUANTITY_MAX_LIMIT',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	TOGGLE_IN_STOP = 'TOGGLE_IN_STOP',
	TOGGLE_IS_RESTRICTED = 'TOGGLE_IS_RESTRICTED',
	TOGGLE_IS_PRESELECTED = 'TOGGLE_IS_PRESELECTED',
	TOGGLE_FORCE_DISABLE = 'TOGGLE_FORCE_DISABLE',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetInitialFormData {
	type: SaveAsPatchActionTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: ISaveAsPatchContext['initialFormData'];
	};
}

interface ISetTypeOfChanges {
	type: SaveAsPatchActionTypes.SET_TYPE_OF_CHANGES;
	payload: {
		typeOfChanges: ISaveAsPatchContext['typeOfChanges'];
		IDsSelectedRestaurant: ISaveAsPatchContext['IDsSelectedRestaurant'];
	};
}

interface ISetIDsRestaurant {
	type: SaveAsPatchActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: ISaveAsPatchContext['IDsSelectedRestaurant'];
	};
}

interface ISetProperties {
	type: SaveAsPatchActionTypes.SET_PROPERTIES;
	payload: {
		selectedProperties: ISaveAsPatchContext['selectedProperties'];
	};
}

interface IChangePrice {
	type: SaveAsPatchActionTypes.CHANGE_PRICE;
	payload: {
		price: ISaveAsPatchContext['price'];
	};
}

interface IChangeSupplementPrice {
	type: SaveAsPatchActionTypes.CHANGE_SUPPLEMENT_PRICE;
	payload: {
		supplementPrice: ISaveAsPatchContext['supplementPrice'];
	};
}

interface IChangeQuantityMaxLimit {
	type: SaveAsPatchActionTypes.CHANGE_QUANTITY_MAX_LIMIT;
	payload: {
		quantityMaxLimit: ISaveAsPatchContext['quantityMaxLimit'];
	};
}

interface IChangeActivationSchedule {
	type: SaveAsPatchActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: ISaveAsPatchContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: SaveAsPatchActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: ISaveAsPatchContext['deactivationSchedule'];
	};
}

interface IToggleInStop {
	type: SaveAsPatchActionTypes.TOGGLE_IN_STOP;
}

interface IToggleIsRestricted {
	type: SaveAsPatchActionTypes.TOGGLE_IS_RESTRICTED;
}

interface IToggleIsPreselected {
	type: SaveAsPatchActionTypes.TOGGLE_IS_PRESELECTED;
}

interface IToggleForceDisable {
	type: SaveAsPatchActionTypes.TOGGLE_FORCE_DISABLE;
}

interface IChangeTypeOfModalWindow {
	type: SaveAsPatchActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ISaveAsPatchContext['typeOfModalWindow'];
	};
}

interface IResetFields {
	type: SaveAsPatchActionTypes.RESET_FIELDS;
}

export type TSaveAsPatchAction =
	| ISetInitialFormData
	| ISetTypeOfChanges
	| ISetIDsRestaurant
	| ISetProperties
	| IChangePrice
	| IChangeSupplementPrice
	| IChangeQuantityMaxLimit
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| IToggleInStop
	| IToggleIsRestricted
	| IToggleIsPreselected
	| IToggleForceDisable
	| IChangeTypeOfModalWindow
	| IResetFields;
